/**
 * Returns an empty string
 *
 * @example
 * ```ts
 * import { constEmptyString } from '@catawiki/runtime-toolkit';
 *
 * const str = constEmptyString();
 *
 * assert.strictEqual(str, '');
 * ```
 */
export const constEmptyString = () => '';
/**
 * Returns an empty readonly array
 *
 * @example
 * ```ts
 * import { constEmptyArray } from '@catawiki/runtime-toolkit';
 *
 * const arr = constEmptyArray();
 *
 * assert.deepStrictEqual(arr, []);
 * ```
 */
export const constEmptyArray = () => [];
/**
 * Returns zero as a number
 *
 * @example
 * ```ts
 * import { constZero } from '@catawiki/runtime-toolkit';
 *
 * const zero = constZero();
 *
 * assert.strictEqual(zero, 0);
 * ```
 */
export const constZero = () => 0;
/**
 * Returns an empty string
 *
 * @example
 * ```ts
 * import { constNaN } from '@catawiki/runtime-toolkit';
 *
 * const notANumber = constNaN();
 *
 * assert.strictEqual(notANumber, Number.NaN);
 * ```
 */
export const constNaN = () => Number.NaN;
